import { AdditionalDetailResponseBuilder } from './AdditionalDetailResponseBuilder';
import { BenefitItemsReferenceResponseBuilder } from './BenefitItemsReferenceResponseBuilder';
import { TicketingResponseBuilder } from './TicketingResponseBuilder';
import { BookingRequirementResponseBuilder } from './BookingRequirementResponseBuilder';
import { LogisticResponseBuilder } from './LogisticResponseBuilder';
import { ItineraryReferenceResponseBuilder } from './ItineraryReferenceResponseBuilder';
import { OfferDetailResponseBuilder } from './OfferDetailResponseBuilder';
import { LanguageGuideResponseBuilder } from './LanguageGuideResponseBuilder';
import { GenericContentSectionResponseBuilder } from './GenericContentSectionResponseBuilder';
import { OfferGroupDetailResponseBuilder } from './OfferGroupDetailResponseBuilder';
import { OfferTagGroupResponseBuilder } from './OfferTagGroupResponseBuilder';
import { LocationResponseBuilder } from './LocationResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class DetailResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('Detail');
    }
    public withAdditionalDetails = (builder: AdditionalDetailResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['additionalDetails'] = this.initField(builder, args);
        return this;
    }

    public withInclusions = (builder: BenefitItemsReferenceResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['inclusions'] = this.initField(builder, args);
        return this;
    }

    public withExclusions = (builder: BenefitItemsReferenceResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['exclusions'] = this.initField(builder, args);
        return this;
    }

    public withTicketing = (builder: TicketingResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['ticketing'] = this.initField(builder, args);
        return this;
    }

    public withBookingRequirements = (builder: BookingRequirementResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['bookingRequirements'] = this.initField(builder, args);
        return this;
    }

    public withLogistics = (builder: LogisticResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['logistics'] = this.initField(builder, args);
        return this;
    }

    public withItineraries = (builder: ItineraryReferenceResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['itineraries'] = this.initField(builder, args);
        return this;
    }

    public withOfferDetails = (builder: OfferDetailResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerDetails'] = this.initField(builder, args);
        return this;
    }

    public withLanguageGuides = (builder: LanguageGuideResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['languageGuides'] = this.initField(builder, args);
        return this;
    }

    public withGenericSection = (builder: GenericContentSectionResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['genericSection'] = this.initField(builder, args);
        return this;
    }

    public withOfferGroupDetails = (builder: OfferGroupDetailResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerGroupDetails'] = this.initField(builder, args);
        return this;
    }

    public withAboutActivity = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['aboutActivity'] = this.initField(null, args);
        return this;
    }

    public withOfferTagGroup = (builder: OfferTagGroupResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['offerTagGroup'] = this.initField(builder, args);
        return this;
    }

    public withLocations = (builder: LocationResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['locations'] = this.initField(builder, args);
        return this;
    }
}
